<template>
  <div class="base-form-div">
    <el-tabs class="base-tabs" type="border-card">
      <el-tab-pane label="基本信息">
        <el-form
          size="mini"
          :label-position="labelPosition"
          label-width="80px"
          :model="formSet"
        >
          <el-form-item label="名称">
            <el-input v-model="name"></el-input>
          </el-form-item>
          <el-form-item label="是否显示">
            <el-switch
              v-model="formBillboard.show"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="图标">
            <el-select
              @change="selectChange"
              v-model="formBillboard.image"
              placeholder="请选择"
            >
              <el-option
                v-for="item in optionsImage"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <!-- <el-input v-model="formBillboard.image"></el-input> -->
            <el-button class="base-button" size="mini" type="primary" @click="changeImg"
              >更多图标...</el-button
            >
          </el-form-item>
          <el-form-item label="图标宽度">
            <el-input-number
              v-model="formBillboard.width"
              controls-position="right"
              :min="0"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="图标高度">
            <el-input-number
              v-model="formBillboard.height"
              controls-position="right"
              :min="0"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="图标比例">
            <el-input-number
              v-model="formBillboard.scale"
              controls-position="right"
              :min="0"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="混合颜色">
            <el-color-picker
              :predefine="predefineColors"
              show-alpha
              v-model="formBillboard.color"
            ></el-color-picker>
          </el-form-item>
          <el-form-item label="旋转角度">
            <el-input-number
              v-model="formBillboard.rotation"
              controls-position="right"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="横向偏移">
            <el-input-number
              v-model="formBillboard.pixelOffsetX"
              controls-position="right"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="竖向偏移">
            <el-input-number
              v-model="formBillboard.pixelOffsetY"
              controls-position="right"
            ></el-input-number>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="文本注记">
        <el-form
          size="mini"
          :label-position="labelPosition"
          label-width="80px"
          :model="formLabel"
        >
          <el-form-item label="是否显示">
            <el-switch
              v-model="formLabel.show"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="文本内容">
            <el-input v-model="formLabel.text"></el-input>
          </el-form-item>
          <el-form-item label="字体类型">
            <el-select v-model="formLabel.fontName" placeholder="请选择">
              <el-option
                v-for="item in optionsFont"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="字体颜色">
            <el-color-picker
              :predefine="predefineColors"
              show-alpha
              v-model="formLabel.fillColor"
            ></el-color-picker>
          </el-form-item>
          <el-form-item label="字体大小">
            <el-input-number
              v-model="formLabel.fontSize"
              controls-position="right"
              :min="0"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="字体比例">
            <el-input-number
              v-model="formLabel.scale"
              controls-position="right"
              :min="0"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="横向偏移">
            <el-input-number
              v-model="formLabel.pixelOffsetX"
              controls-position="right"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="竖向偏移">
            <el-input-number
              v-model="formLabel.pixelOffsetY"
              controls-position="right"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="是否有背景">
            <el-switch
              v-model="formLabel.showBackground"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
          </el-form-item>
          <el-form-item v-show="formLabel.showBackground" label="背景颜色">
            <el-color-picker
              :predefine="predefineColors"
              show-alpha
              v-model="formLabel.backgroundColor"
            ></el-color-picker>
          </el-form-item>
          <el-form-item v-show="formLabel.showBackground" label="左右内边距">
            <el-input-number
              v-model="formLabel.backgroundPaddingX"
              controls-position="right"
              :min="0"
            ></el-input-number>
          </el-form-item>
          <el-form-item v-show="formLabel.showBackground" label="上下内边距">
            <el-input-number
              v-model="formLabel.backgroundPaddingY"
              controls-position="right"
              :min="0"
            ></el-input-number>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>

    <div class="form-bottom">
      <el-button class="base-button" size="mini" type="primary" @click="savePlot"
        >保存</el-button
      >
      <!-- <el-button class="base-button" size="mini" type="primary" @click="exportPlot">导出</el-button> -->
      <el-button class="base-button" size="mini" type="primary" @click="deletePlot"
        >删除</el-button
      >
    </div>
  </div>
</template>

<script>
// Serif 衬线字体，字体边缘具有明显的艺术修饰效果，主要用于标题、大字体。如，宋体，Times New Roman

// Sans-Serif 非衬线字体，字体比划一般粗细均匀、清晰，主要用于少量正文。如，微软雅黑，Arial

// Monospace 等宽字体，主要针对英文，每个字符的宽度一致，如编程常用的字体。如，Consolas，Courier New
import { createMark, deleteByMarkId } from "@/api/vectorPlot/index.js";
import StyleUtil from "@/utils/cesiumBD/utils/StyleUtil.js";
import * as Help from "@/components/PlanEditor/Actions/help.js";
import imgTree from "../imgTree.vue";
let entity;
export default {
  props: ["subData"],
  data() {
    return {
      predefineColors: ["#ff0000", "#0000ff", "#00ff00", "#00ffff"],
      labelPosition: "left",
      formSet: {
        pixelSize: 10,
        color: "",
        outlineColor: "",
        outlineWidth: 0,
        materialOption: {},
      },
      name: "点",
      optionsFont: [
        {
          value: "serif",
          label: "衬线字体",
        },
        {
          value: "sans-serif",
          label: "非衬线字体",
        },
        {
          value: "monospace",
          label: "等宽字体",
        },
      ],
      formLabel: {
        materialOption: {},
        text: "",
        fillColor: "",
        fontName: "sans-serif",
        fontSize: 20,
        scale: 1,
        showBackground: false,
        backgroundColor: "",
        backgroundPaddingX: 7,
        backgroundPaddingY: 5,
        pixelOffsetX: 0,
        pixelOffsetY: 0,
      },
      optionsImage: [
        //sb.svg
        // {
        //   value: "data/img/marker/sb.svg", //64X64
        //   label: "士兵",
        // },
        // {
        //   value: "data/img/marker/tk.svg", //64X64
        //   label: "坦克",
        // },
        // {
        //   value: "data/img/marker/hzj.svg", //64X64
        //   label: "轰炸机",
        // },

        {
          value: "data/img/marker/street.png",
          label: "监控标记",
        },
        {
          value: "data/img/marker/mark2.png",
          label: "重要标记",
        },
        {
          value: "data/img/marker/mark3.png",
          label: "普通标记",
        },
      ],
      formBillboard: {
        materialOption: {},
        image: "data/img/marker/mark2.png",
        imageUrl: "",
        scale: 1,
        pixelOffsetX: 0,
        pixelOffsetY: 0,
        color: "",
        rotation: 0,
        width: 20,
        height: 20,
      },
    };
  },

  watch: {
    formLabel: {
      // 数据变化时执行的逻辑代码
      handler(newObj, oldObj) {
        StyleUtil.setStyle2Entity(newObj, entity, "label");
      },
      // 开启深度监听
      deep: true,
    },
    formBillboard: {
      // 数据变化时执行的逻辑代码
      handler(newObj, oldObj) {
        StyleUtil.setStyle2Entity(newObj, entity, "billboard");
      },
      // 开启深度监听
      deep: true,
    },
  },

  mounted() {
    if (typeof this.subData == "function") {
      entity = this.subData();
    } else {
      entity = this.subData.entity;
    }
    this.name = entity.markName || entity.typeName;
    //回显
    if (entity["billboard"]["attr"] && entity["billboard"]["attr"].materialType) {
      this.formSet.materialType = entity["billboard"]["attr"].materialType;
    }
    this.changeMaterialType();
    console.log(entity);

    this.$bus.$on("saveBillBoardData", (item) => {
      this.formBillboard.image = item.imageUrl;
      this.formBillboard.imageUrl = item.imageUrl;
    });
  },

  beforeDestroy() {
    this.$bus.$off("saveBillBoardData");
  },
  methods: {
    selectChange(val) {
      this.formBillboard.imageUrl = val;
    },
    changeImg(val) {
      this.$dialog.open({
        id: "图标选择",
        title: "图标选择",
        area: {
          height: "800px",
          width: "300px",
        },
        content: {
          type: "vue",
          subCom: imgTree,
          subData: null,
        },
      });
    },
    changeMaterialType() {
      let formLabel = StyleUtil.getEntity2Style(this.formLabel, entity, "label");
      this.formLabel = formLabel;

      let formBillboard = StyleUtil.getEntity2Style(
        this.formBillboard,
        entity,
        "billboard"
      );
      this.formBillboard = formBillboard;

      console.log("formBillboard");
      console.log(formBillboard);
    },
    savePlot() {
      let style = StyleUtil.getEntity2Style(this.formSet, entity, "billboard");

      // if (this.formBillboard && this.formBillboard.image.startsWith("blobJB:")) {
      //   style.image = this.formBillboard.image;
      // }

      style.imageUrl = this.formBillboard.imageUrl;
      //StyleUtil.setStyle2Entity(this.formBillboard, entity, "billboard");
      //entity["billboard"]["attr"].formLabel = this.formLabel;
      style.formLabel = this.formLabel;
      let data = {
        extType: entity.typeName,
        editPositions: JSON.stringify(entity.position.getValue()),
        //styleAttr: JSON.stringify(entity["billboard"]["attr"]),
        styleAttr: JSON.stringify(style),
        postureAttr: "",
        userId: 111,
        markId: entity.id,
        markName: this.name,
      };

      console.log(data);
      let action = {};
      action.name = this.name;
      action.type = "commonPlot";
      action.typeName = "常用标绘";
      action.delay = 1;
      action.data = data;

      if (entity.isAlreadyPlotflag) {
        entity.markName = this.name;
        entity.update(action);
        this.$parent.close();
        return;
      }
      if (typeof this.subData != "function") {
        this.subData.update(action);
        this.$parent.close();
        return;
      }

      if (entity.isPlotflag) {
        this.$bus.$emit("addActionObj", action);
        Help.addEntityArr(entity);
        this.$parent.close();
        return;
      }

      createMark(data)
        .then((res) => {
          this.$message({
            showClose: true,
            message: "保存成功,请到我的标绘中进行查看！",
            type: "success",
            duration: 3 * 1000,
          });
          this.$bus.$emit("vectorPlot-list");

          entity.markName = data.markName;
        })
        .catch((err) => {
          console.err(err);
        });
    },
    exportPlot() {},
    deletePlot() {
      if (entity.isPlotflag) {
        StyleUtil.deletePlot(entity);
        this.$parent.close();
        return;
      }
      this.$confirm("是否删除该条数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteByMarkId(entity.id).then((res) => {
            console.log(res);
            this.$message({
              showClose: true,
              message: "删除成功！",
              type: "success",
              duration: 3 * 1000,
            });
            this.$bus.$emit("vectorPlot-list");
            StyleUtil.deletePlot(entity);
            this.$parent.close();
          });
        })
        .catch(() => {
          this.$message({
            showClose: true,
            type: "info",
            message: "本次操作已取消！",
            duration: 3 * 1000,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.base-form-div {
  padding: 20px;
}

.form-bottom {
  text-align: center;
  border-top: 1px solid rgba(153, 153, 153, 0.5);
  padding-top: 20px;
}
</style>
